// eslint-disable-next-line
import * as zoom from 'chartjs-plugin-zoom';
export const ChartOptions = {
    LineChartOptions: {
        layout: {
            padding: {
                left: 20,
                right: 20,
                top: 30,
                bottom: 30
            }
        },
        legend: {
            display: false
        },
        tooltips: {
            mode: 'index'
        },
        maintainAspectRatio: false,
        pan: {
            enabled: true,
            mode: 'x'
        },
        zoom: {
            enabled: true,
            drag: true,
            mode: 'xy'
        }
    },
    PieChartOptions: {
        legend: {
            display: false
        },
        maintainAspectRatio: false
    }
};